'use client'
import { cn } from '@/lib/utils'

type Pose = 'point' | 'cool'

const SRC: any = {
    point: '/assets/images/platform/mascot-point.png',
    cool: '/assets/images/platform/mascot-cool.png',
}

interface MascotProps {
    pose?: Pose
    note?: string
    className?: string
    imageClassName?: string
    priority?: boolean
    noteClassName?: string
}

const Mascot = ({ pose = 'point', note, className, imageClassName, priority, noteClassName }: MascotProps) => (
    <div className={cn('relative flex items-end justify-center', className)}>
        <img
            src={SRC[pose]}
            alt="Маскот VCENTRE.IT — жёлтый утёнок в чёрном худи"
            width={1024}
            height={1024}
            loading={priority ? 'eager' : 'lazy'}
            className={cn('w-full max-w-[280px] drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)]', imageClassName)}
        />
        {note && (
            <span className={cn('handwritten absolute -top-2 right-0 -rotate-6 whitespace-nowrap sm:text-2xl', noteClassName)}>{note}</span>
        )}
    </div>
)

export default Mascot
